// extracted by mini-css-extract-plugin
module.exports = {"container":"switchColorStyle_container__3gq6Y"};